import { IBaseResponseResult } from "./ibase-response-result";
import { Error } from "./error";

export class BaseResponseResult<T> implements IBaseResponseResult<T> {
  ObjectResult: T;
  ListResult: T[];
  Filter: any;
  Success: boolean;
  Errors: {
    [key: string]: Error;
  };
  constructor(data?: Partial<BaseResponseResult<T>>) {
    Object.assign(this, data);
  }
}
